import React from "react";

function DTOFeedback() {
  return <></>;
}
export default DTOFeedback;
